// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Journey-Service (J-S::B2C) API
 * ## SBB Journey-Planner  (de:Fahrplanpublikation Personenverkehr SBB)  This is a stateless RESTful web-service for **timetable based public transportation routing** as provided by SBB Journey-Planner applications such as [sbb.ch](https://www.sbb.ch/) or [SBB Mobile App](https://apps.apple.com/ch/app/sbb-mobile/id294855237). The service-contract is restricted to **SBB internal consumers** or **accredited partners** and supports various and enhanced use cases.  ### Before \'Sign up\'  For new consumers: 1. This **service needs official approval** before granting any access, therefore send an e-mail (see \'Contact -> E-Mail\') first with the subject: **Request: Sign Up Journey-Service** 2. Wait for the appropriate response e-mail and fill-in the attached **Questionnaire** and follow further steps given in the response.    ### Approved and \'Signed up\' consumers See **Contact** box * **Homepage** for general infos about the service  * **Developer resources** for specific usage and concepts of Journey-Service  See **Blog** on PRODuction for Release-Notes.  Remark: * Please read the **Service-Contract** description in Swagger-Doc carefully. * For further questions, send an e-Mail.  
 *
 * The version of the OpenAPI document: 3.20.32.2
 * Contact: journey-service@sbb.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import { AccessLeg, AccessLegFromJSONTyped, AccessLegToJSON, AccessLegToJSONTyped } from './AccessLeg';
import { AlternativeModeLeg, AlternativeModeLegFromJSONTyped, AlternativeModeLegToJSON, AlternativeModeLegToJSONTyped } from './AlternativeModeLeg';
import { PTConnectionLeg, PTConnectionLegFromJSONTyped, PTConnectionLegToJSON, PTConnectionLegToJSONTyped } from './PTConnectionLeg';
import { PTRideLeg, PTRideLegFromJSONTyped, PTRideLegToJSON, PTRideLegToJSONTyped } from './PTRideLeg';
import { PersonalLeg, PersonalLegFromJSONTyped, PersonalLegToJSON, PersonalLegToJSONTyped } from './PersonalLeg';
/**
 * **Abstract Superclass** of concrete inherited sub-classes **{`PTRideLeg`, `AccessLeg`, `PTConnectionLeg`, `PersonalLeg`, `AlternativeModeLeg`}** (aka OJP TripLeg).
 * @export
 * @interface Leg
 */
export interface Leg {
    /**
     * Mode of the Leg:
     * - `AccessLeg` {FOOT,ROAD}
     * - `PTRideLeg`{values according to `VehicleMode::id`, see more details in `ServiceProduct::vehicleMode`
     * - `PTConnectionLeg` {TRANSFER}
     * - `PersonalLeg` {FOOT,ROAD}
     * - `AlternativeModeLeg` (future use and undefined yet)
     * @type {string}
     * @memberof Leg
     */
    mode: string;
    /**
     * Unique Index ordered within Trip (may be casted to Integer for local indexing).
     * @type {string}
     * @memberof Leg
     */
    id: string;
    /**
     * [duration](https://www.w3.org/TR/xmlschema11-2/#duration)
     * @type {string}
     * @memberof Leg
     */
    duration?: string;
    /**
     * Total distance for Leg (in meter).
     * @type {number}
     * @memberof Leg
     */
    distance?: number;
    /**
     * **Inheritance discriminator to proper Subclass** (technical field required by [OpenApi 3 Discriminator](https://swagger.io/docs/specification/data-models/inheritance-and-polymorphism/)) makes deserialization at consumer side easier.
     * @type {string}
     * @memberof Leg
     */
    type: string;
}

/**
 * Check if a given object implements the Leg interface.
 */
export function instanceOfLeg(value: object): value is Leg {
    if (!('mode' in value) || value['mode'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function LegFromJSON(json: any): Leg {
    return LegFromJSONTyped(json, false);
}

export function LegFromJSONTyped(json: any, ignoreDiscriminator: boolean): Leg {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json['type'] === 'AccessLeg') {
            return AccessLegFromJSONTyped(json, ignoreDiscriminator);
        }
        if (json['type'] === 'AlternativeModeLeg') {
            return AlternativeModeLegFromJSONTyped(json, ignoreDiscriminator);
        }
        if (json['type'] === 'PTConnectionLeg') {
            return PTConnectionLegFromJSONTyped(json, ignoreDiscriminator);
        }
        if (json['type'] === 'PTRideLeg') {
            return PTRideLegFromJSONTyped(json, ignoreDiscriminator);
        }
        if (json['type'] === 'PersonalLeg') {
            return PersonalLegFromJSONTyped(json, ignoreDiscriminator);
        }
    }
    return {
        
        'mode': json['mode'],
        'id': json['id'],
        'duration': json['duration'] == null ? undefined : json['duration'],
        'distance': json['distance'] == null ? undefined : json['distance'],
        'type': json['type'],
    };
}

  export function LegToJSON(json: any): Leg {
      return LegToJSONTyped(json, false);
  }

  export function LegToJSONTyped(value?: Leg | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (!ignoreDiscriminator) {
        switch (value['type']) {
            case 'AccessLeg':
                return AccessLegToJSONTyped(value as AccessLeg, ignoreDiscriminator);
            case 'AlternativeModeLeg':
                return AlternativeModeLegToJSONTyped(value as AlternativeModeLeg, ignoreDiscriminator);
            case 'PTConnectionLeg':
                return PTConnectionLegToJSONTyped(value as PTConnectionLeg, ignoreDiscriminator);
            case 'PTRideLeg':
                return PTRideLegToJSONTyped(value as PTRideLeg, ignoreDiscriminator);
            case 'PersonalLeg':
                return PersonalLegToJSONTyped(value as PersonalLeg, ignoreDiscriminator);
            default:
                throw new Error(`No variant of Leg exists with 'type=${value['type']}'`);
        }
    }

    return {
        
        'mode': value['mode'],
        'id': value['id'],
        'duration': value['duration'],
        'distance': value['distance'],
        'type': value['type'],
    };
}

